<template>
  <div>
    <el-dialog :title="title" :visible="localVisible" width="70%" @close="onClose">
      <el-form label-width="110px" :inline="true" size="mini">
        <el-form-item label="轮毂名称">
          <el-input 
            v-model="keywords" 
            clearable 
            placeholder="请输入轮毂名称"
          ></el-input>
        </el-form-item>
        
        <!-- 新增：分类名 远程搜索 多选下拉 -->
        <el-form-item label="孔距">
          <el-select
            v-model="pitchIds"
            multiple
            filterable
            clearable
            remote
            reserve-keyword
            placeholder="请输入孔距搜索"
            :remote-method="remoteSearchPitch"
            :loading="pitchLoading"
            style="width: 240px"
          >
            <el-option
              v-for="item in pitchList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="chooseItem">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      
      <div>
        <el-table
          ref="multipleTable"
          :data="mList"
          height="300"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          @selection-change="handleSelectionChange"
        >
          <!-- 单选 → 替换为 多选列 -->
          <el-table-column type="selection" width="50" align="center" />
          
          <el-table-column
            label="轮毂名称"
            width="120"
            prop="goods_name"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="中心孔"
            width="100"
            prop="center_bore"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="ET"
            width="100"
            prop="et"
            :show-overflow-tooltip="true"
          />
            <el-table-column
            label="孔距"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
             {{scope.row.pitch.name||'' }}
            </template>
          </el-table-column>
          <el-table-column
            label="图片"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 40px; height: 40px"
                :src="scope.row.goods_img"
                fit="cover"
              />
            </template>
          </el-table-column>
        </el-table>
        
        <div class="block" style="margin-top:10px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
        
        <el-row>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="close">取消</el-button>
            <el-button size="mini" type="primary" @click="ok">确定</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'eShopList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    closeForm: Function
  },
  data() {
    return {
      localVisible: false,
      // 搜索条件
      keywords: '',
      pitchIds: [], // 多选分类ID
      pitchList: [], // 分类下拉列表
      pitchLoading: false, // 分类搜索loading
      // 表格数据
      mList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 多选选中项
      selectedList: []
    }
  },
  methods: {
    // 分页条数改变
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    // 分页页码改变
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    // 关闭弹窗
    onClose() {
      this.$emit('update:visible', false)
      this.closeForm?.()
      this.resetQuery() // 清空所有条件
    },
    // 取消按钮
    close() {
      this.onClose()
    },
    // 确定按钮 → 返回多选数据
    ok() {
      if (this.selectedList.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      // 向外抛出选中的数组
      this.$emit('eventChoose', this.selectedList)
      this.onClose()
    },
    // 表格多选监听
    handleSelectionChange(val) {
      this.selectedList = val
    },
    // 获取商品列表（支持名称+分类IDS查询）
    DataList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: sessionStorage.getItem('shop_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keywords: this.keywords?.trim() || '',
        // 多选分类ID数组传给后端
        pitch_ids: this.pitchIds.length > 0 ? this.pitchIds.join(',') : ''
      }
      this.$axios.findByCarGoodsListP(param)
        .then((res) => {
          if (res.code === 200) {
            this.mList = res.data.data
            this.total = res.data.total
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 分类远程搜索
    remoteSearchPitch(keyword) {
      if (!keyword) {
        this.pitchList = []
        return
      }
      this.pitchLoading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: sessionStorage.getItem('shop_id'),
        keywords: keyword,
      }
      this.$axios
        .findPitchTable(param)
        .then((res) => {
          if (res.code === 200) {
            this.pitchList = res.data
          }
        })
        .finally(() => {
          this.pitchLoading = false
        })
    },
    // 查询按钮
    chooseItem() {
      this.pageNum = 1
      this.DataList()
    },
    // 重置查询条件
    resetQuery() {
      this.keywords = ''
      this.pitchIds = []
      this.pageNum = 1
      this.selectedList = []
      this.pitchList = []
      this.$refs.multipleTable?.clearSelection()
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
      if (val) {
        this.DataList()
      } else {
        this.resetQuery()
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 原有样式保留
.upload_group {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .upload_list {
    width: 120px;
    margin-right: 1rem;
  }

  /deep/ .el-upload-dragger .el-upload__text {
    font-size: 10px;
    color: #409eff;
  }

  /deep/ .el-icon-upload:before {
    width: 40px !important;
    height: 40px !important;
  }

  .upload_list:last-child {
    margin-right: 0;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border: 1px solid #999;
  }

  /deep/ .el-upload {
    width: 100%;
  }

  /deep/ .el-upload-dragger .el-icon-upload {
    margin: 10px 0;
  }
}
.table_name:hover {
  color: #409eff;
  cursor: pointer;
}
</style>